exports = module.exports = require("../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".list.ant-list-bordered{border-radius:0;border:none}.list ul{list-style:none}.list ul li{position:relative}.list li:after{content:\"\";width:0;height:0;display:block;overflow:hidden;clear:both}.list li img{width:40px;margin-right:10px}.list li i{position:absolute;top:22px;right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./src/styles/list.css
// module id = 804
// module chunks = 0